export default "__VITE_ASSET__aJXI$i7D__"